import { Pipe, PipeTransform } from '@angular/core';
import { IIdAndName } from '../../core/interfaces/IIdAndName';

@Pipe({
  name: 'idAndName',
  standalone: true
})
export class IdAndNamePipe implements PipeTransform {
  public transform(value: any[], idProp = 'id', nameProp = 'name', disabledProp = 'isDisabled', namespace?: string): (IIdAndName & { [key: string]: any })[] {
    return Array.isArray(value) ? value.map(obj => ({
      id: obj[idProp],
      name: namespace ? (obj[nameProp] as string).trans(namespace + obj[nameProp]) : obj[nameProp],
      isDisabled: obj[disabledProp] ?? false
    })) : [];
  }
}
